import React from 'react'
import MySpiner from '../../../UI/spiner/MySpiner'
import { useState } from 'react'
import { useEffect } from 'react'
import { responseError } from '../../../../helpers/response/ResponseHelper'
import { getSeriesGoodDataBySeriesScanForVtkAPI } from '../../../../api/pack/seriesAPI'

const PackingConfirmGetSeriesData = ({ goodFromBd, setGoodFromBd, valueScan }) => {

    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')

    useEffect(() => {
        getGoodDataByScan()
    }, [valueScan])

    const getGoodDataByScan = () => {
        setLoading(true)
        setError('')

        getSeriesGoodDataBySeriesScanForVtkAPI({
            scanData: valueScan,
        }).then(data => {
            setGoodFromBd(data)
            setLoading(false)
        }).catch(e => {
            setError(responseError(e))
            setLoading(false)
        })
    }

  return (
     <div>
        {
            loading ? <MySpiner /> : ''
        }

        {
            error ? 
                <div className='error'>
                    {error}
                </div>
            : ''
        }
    </div>
  )
}

export default PackingConfirmGetSeriesData